export default function Chadname() {
    return (
        <div className="flex flex-col justify-center items-center  bg-[#001D21]">
          <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-[#FB8569] md:text-5xl lg:text-8xl dark:text-white">
            CHAD
          </h1>
          <h1 className="text-4xl font-extrabold tracking-tight leading-none text-[#FB8569] md:text-5xl lg:text-2xl dark:text-white text-center">
            Code Heuristic Assessment and Debugging
          </h1>
        </div>
      );
      
}
